import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3feb7f2e")

_pushScopeId("data-v-3feb7f2e")
const _hoisted_1 = { class: "dt-open-api-content dt-open-api-personal-add-app-container" }
const _hoisted_2 = { class: "dt-open-api-personal-add-app-box" }
const _hoisted_3 = { class: "dt-open-api-personal-add-app-setup-content" }
const _hoisted_4 = { class: "dt-appmange-form-row dt-appmange-form-row-icon" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "dt-appmange-form-row-icon-item-img" }, [
  /*#__PURE__*/_createVNode("div", { class: "dt-appmange-form-row-icon-add" })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "dt-appmange-form-row-icon-item"
}
const _hoisted_7 = { class: "dt-appmange-form-row-icon-item-img" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "dt-open-api-upload-info clearfix" }, "文件支持jpg、jpeg、bmp、png格式图片，大小不超过5MB", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref: "formItemRef",
          model: _ctx.formItem,
          rules: _ctx.rules,
          "label-width": "130px"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "公司名称",
              prop: "enterpriseFullName"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formItem.enterpriseFullName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.formItem.enterpriseFullName = $event)),
                  placeholder: "请输入公司名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司简称",
              prop: "introduce"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formItem.enterpriseShortName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.formItem.enterpriseShortName = $event)),
                  placeholder: "请输入公司简称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "统一社会信用码",
              prop: "unifiedSocialCreditCode"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formItem.unifiedSocialCreditCode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.formItem.unifiedSocialCreditCode = $event)),
                  placeholder: "请输入18位字母、数字，字母区分大小写"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "地区",
              class: "dt-open-api-register-area-row",
              prop: "provinceId",
              rules: [{ required: true, message: '请选择地区'}]
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.provinceId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.provinceId = $event)),
                  onChange: _cache[5] || (_cache[5] = $event => (_ctx.onProvinceChange($event,1))),
                  placeholder: "省",
                  "no-data-text": "暂无数据"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.provinces, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.areaName,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.cityId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.cityId = $event)),
                  onChange: _cache[7] || (_cache[7] = $event => (_ctx.onProvinceChange($event,2))),
                  placeholder: "市",
                  "no-data-text": "暂无数据"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.citys, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.areaName,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.districtId,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (_ctx.districtId = $event)),
                  onChange: _cache[9] || (_cache[9] = $event => (_ctx.onProvinceChange($event,3))),
                  placeholder: "区",
                  "no-data-text": "暂无数据"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.districts, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.areaName,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "营业执照",
              prop: "businessLicense"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_4, [
                  _createVNode("input", {
                    type: "file",
                    id: "uploadImg",
                    ref: "fileInput",
                    onChange: _cache[10] || (_cache[10] = (...args) => (_ctx.imgToUpload(...args))),
                    class: "dt-open-api-upload-input",
                    accept: "image/*"
                  }, null, 544),
                  _createVNode("div", {
                    class: "dt-appmange-form-row-icon-item click-element",
                    onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.uploadImgClick(...args)))
                  }, [
                    _hoisted_5
                  ]),
                  (_ctx.formItem.businessLicense)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode("div", _hoisted_7, [
                          _createVNode("img", {
                            src: _ctx.formItem.businessLicense
                          }, null, 8, ["src"]),
                          _createVNode("div", {
                            class: "dt-appmange-form-row-icon-item-img-remove-icon click-element",
                            onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.clearnImg(...args)))
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.saveFactoryInfo
                }, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ]))
})